import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from './AdminLayout';
import { useAuth } from '../../context/AuthContext';

export default function AdminOrderSync() {
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(null);
  const base = `${process.env.REACT_APP_BACKEND_URL}/api/admin/integrations/orders`;
  const load = useCallback(async () => {
    try { setData((await axios.get(base, { headers: { Authorization: `Bearer ${token}` } })).data); setError(''); }
    catch { setError('Could not load the integration queue.'); }
  }, [base, token]);
  useEffect(() => { if (token) load(); }, [load, token]);
  const retry = async (id) => {
    setBusy(id);
    try { await axios.post(`${base}/${id}/retry`, {}, { headers: { Authorization: `Bearer ${token}` } }); await load(); }
    catch { setError('Could not queue the retry.'); }
    finally { setBusy(null); }
  };
  return <AdminLayout><div className="space-y-6">
    <div className="flex flex-wrap items-center justify-between gap-3"><h1 className="text-2xl font-bold">Order sync</h1>
      <button onClick={load} className="min-h-[44px] rounded border px-4">Refresh</button></div>
    <p className="text-sm text-muted-foreground">Pending imports, payment events, and delivery failures. Fix the reported issue before retrying a failed job.</p>
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {!data && !error && <p role="status">Loading…</p>}
    {data && <>
      <p className="text-sm">Prometheus sync: {data.enabled ? 'Enabled' : 'Disabled'} · Portal balance payments: {data.balance_payments_enabled ? 'Enabled' : 'Disabled'}</p>
      {data.jobs.length === 0 ? <p className="rounded border p-5">No pending or failed jobs.</p> : <ul className="divide-y rounded border bg-card">
        {data.jobs.map(job => <li key={job.id} className="p-4 flex flex-wrap items-start justify-between gap-4">
          <div className="min-w-0 flex-1"><p className="font-medium">{job.kind.replaceAll('_', ' ').replace(/highlevel/gi, 'Prometheus')} · {job.status}</p>
            <p className="text-sm text-muted-foreground">{job.attempts} attempts · {new Date(job.created_at).toLocaleString()}</p>
            {job.last_error && <p className="mt-2 text-sm text-red-700 break-words">{job.last_error.replace(/high[ -]?level/gi, 'Prometheus')}</p>}
          </div>
          <button disabled={busy === job.id} onClick={() => retry(job.id)} className="min-h-[44px] rounded border px-4 text-sm disabled:opacity-50">{busy === job.id ? 'Queuing…' : 'Retry'}</button>
        </li>)}
      </ul>}
    </>}
  </div></AdminLayout>;
}
